export const generateUUID = (): string => {
  return (new Date().getTime().toString(16) + Math.random().toString(16).slice(2)).slice(2, 16);
};
